import { AUTHOR_BOTS, AUTHOR_LIST, DEFAULT_AUTHOR_ID, suggestAuthorBot } from '../constants/authorBots';

export const AUTHOR_PERSONAS = AUTHOR_BOTS;
export const AUTHOR_PERSONA_LIST = AUTHOR_LIST;
export { DEFAULT_AUTHOR_ID, suggestAuthorBot };
